var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mt-0 pa-0"},[_c('RechtssammlungComp')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center pb-5"},[_c('h1',{staticClass:"sz-kath-title"},[_vm._v(" Systematische Rechtssammlung der Röm.-kath. Kantonalkirche Schwyz ")])])
}]

export { render, staticRenderFns }